import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/report/attendance';

const timesheetsSummary = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/timeSheets/summary`, data);
};

const timesheetsSummaryExport = (merchantId, data) => {
	return Client.get(
		`${baseUrl}/${merchantId}/timeSheets/summary/export`,
		data,
		{
			responseType: 'blob',
		}
	);
};

const timesheetsDetail = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/timeSheets/detail`, data);
};

const timesheetsDetailExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/timeSheets/detail/export`, data, {
		responseType: 'blob',
	});
};

const employeeSalesSummary = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/employeeSales/summary`, data);
};

const employeeSalesSummaryExport = (merchantId, data) => {
	return Client.get(
		`${baseUrl}/${merchantId}/employeeSales/summary/export`,
		data,
		{
			responseType: 'blob',
		}
	);
};

const employeeSalesDetail = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/employeeSales/detail`, data);
};

const employeeSalesDetailExport = (merchantId, data) => {
	return Client.get(
		`${baseUrl}/${merchantId}/employeeSales/detail/export`,
		data,
		{
			responseType: 'blob',
		}
	);
};

const employeeSalesDetailItem = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/employeeSales/item`, data);
};

const employeeSalesDetailItemExport = (merchantId, data) => {
	return Client.get(
		`${baseUrl}/${merchantId}/employeeSales/item/export`,
		data,
		{
			responseType: 'blob',
		}
	);
};
const deputySalesPerformancesDetailId = (merchantId, salesId) => {
	return Client.get(
		`/gateway/numbat-api/api/vs/manage-sales/${merchantId}/deputySalesPerformances/${salesId}/detail`
	);
};

export default {
	timesheetsSummary,
	timesheetsSummaryExport,
	timesheetsDetail,
	timesheetsDetailExport,
	employeeSalesSummary,
	employeeSalesSummaryExport,
	employeeSalesDetail,
	employeeSalesDetailExport,
	employeeSalesDetailItem,
	employeeSalesDetailItemExport,
	deputySalesPerformancesDetailId,
};
